import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import '../../styles/AdminGridItem.css';

interface AdminGridItemProps {
  title: string;
  icon: IconDefinition;
  description: string;
  onClick: () => void;
}

/**
 * AdminGridItem component - A clickable grid item for admin dashboard navigation
 */
const AdminGridItem: React.FC<AdminGridItemProps> = ({ 
  title, 
  icon, 
  description, 
  onClick 
}) => {
  return (
    <div 
      className="admin-dashboard-grid-item"
      onClick={onClick}
    >
      <div className="grid-item-header">
        <h2>{title}</h2>
      </div>
      <div className="grid-item-content">
        <FontAwesomeIcon icon={icon} className="grid-item-icon" />
        <p className="grid-item-description">
          {description}
        </p>
      </div>
    </div>
  );
};

export default AdminGridItem;
